import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useFavoritesPosts } from '../hooks/useFavoritesPosts';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import PostCard from '../components/PostCard';
import styles from './PostsPage.module.css';

function FavoritePostsPage() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { favorites } = useFavoritesPosts();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      navigate('/');
      return;
    }

    const fetchPosts = async () => {
      if (favorites.length === 0) {
        setPosts([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        // Utiliser where('__name__', 'in', ...) pour récupérer les posts favoris
        // Limitation: 'in' peut avoir max 10 éléments, donc on doit gérer les cas avec plus de 10 favoris
        const maxBatchSize = 10;
        const batches = [];
        for (let i = 0; i < favorites.length; i += maxBatchSize) {
          batches.push(favorites.slice(i, i + maxBatchSize));
        }

        const allPosts = [];
        for (const batch of batches) {
          const q = query(collection(db, 'posts'), where('__name__', 'in', batch));
          const snapshot = await getDocs(q);
          const postsData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          allPosts.push(...postsData);
        }

        // Trier par date de création décroissante
        allPosts.sort((a, b) => {
          const aDate = a.createdAt?.toDate ? a.createdAt.toDate() : (a.createdAt ? new Date(a.createdAt) : new Date(0));
          const bDate = b.createdAt?.toDate ? b.createdAt.toDate() : (b.createdAt ? new Date(b.createdAt) : new Date(0));
          return bDate.getTime() - aDate.getTime();
        });
        setPosts(allPosts);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching favorite posts:', error);
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [currentUser, favorites, navigate]);

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.container}>
          <div className={styles.loading}>Chargement...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>Mes questions favorites</h1>
        </div>
        {posts.length > 0 ? (
          <div className={styles.postsList}>
            {posts.map((post) => (
              <PostCard key={post.id} post={post} currentUser={currentUser} />
            ))}
          </div>
        ) : (
          <div className={styles.empty}>Aucune question favorite pour le moment</div>
        )}
      </div>
    </div>
  );
}

export default FavoritePostsPage;

